import React from 'react'
import styled from 'react-emotion'
import { StyledFormElement } from '../../../../common/FormElement'

const EditName = styled(props => (
  <StyledFormElement Component="input" {...props} />
))({
  flex: 1,
  padding: 0,
  border: 'none',
  fontWeight: 500,
  '&:focus': {
    outline: 'none'
  }
})

export default EditName
